import { Divider, Grid, Typography, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import moment from 'moment';
import { useCallback, useEffect, useRef, useState } from 'react';
import { DateAndTimeCalendarIcon } from '../../assets/customIcons';
import { ChevronLeft, ChevronRight } from '../../assets/images';
import { dateFormate } from '../../utils/utils';
import { MuiIconButton } from '../atoms/iconButtonComponent';
import { MuiStack } from '../atoms/stackComponent';
function CalendarComponent(props) {
    var getCurrentCalendarData = props.getCurrentCalendarData, fullDate = props.fullDate, onArrowDateChange = props.onArrowDateChange, maxSlotValue = props.maxSlotValue, onClickOfSlotBar = props.onClickOfSlotBar, selectedTimeSlot = props.selectedTimeSlot;
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var MAX_BAR_HEIGHT = 90;
    var BAR_HEIGHT_MULTIPLIER = Math.min(maxSlotValue >= 30 ? 3 : 6, MAX_BAR_HEIGHT / maxSlotValue);
    var scrollableRef = useRef(null);
    var _a = useState(0), stackWidth = _a[0], setStackWidth = _a[1];
    var setScrollableRef = useCallback(function (node) {
        if (node !== null) {
            scrollableRef.current = node;
        }
    }, []);
    useEffect(function () {
        if (scrollableRef.current) {
            console.log('Scrollable ref is set:', scrollableRef.current);
        }
    }, [setScrollableRef]);
    var scrollLeft = function () {
        var scrollLeftCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -200;
        if (scrollableRef.current) {
            scrollableRef.current.scrollBy({
                left: scrollLeftCount,
                behavior: 'smooth'
            }); // Adjust the scroll distance as needed
        }
    };
    var scrollRight = function () {
        var scrollRightCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 200;
        if (scrollableRef.current) {
            scrollableRef.current.scrollBy({
                left: scrollRightCount,
                behavior: 'smooth'
            }); // Adjust the scroll distance as needed
        }
    };
    var _b = useState(new Date()), monthYear = _b[0], setMonthYear = _b[1];
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var getPreviousDisble = function () {
        return new Date(fullDate).toDateString() === new Date().toDateString();
    };
    var getSlotDateTime = function () {
        var formatString = fullDate ? dateFormate(new Date(fullDate)) : t('Select date');
        if (selectedTimeSlot && selectedTimeSlot.StartTime) {
            formatString = dateFormate(new Date(fullDate)) + " " + moment(selectedTimeSlot.StartTime).format('h:mm A');
        }
        return formatString;
    };
    return getCurrentCalendarData && Array.isArray(getCurrentCalendarData) && getCurrentCalendarData.length > 0 ? /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 12,
        md: 12,
        sm: 12,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'base',
        fontWeight: 'strong',
        pb: 1,
        sx: {
            '&::after': {
                content: '"*"',
                color: 'red',
                marginLeft: '2px'
            }
        }
    }, t("Date & time slot"))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        lg: 6,
        md: 6,
        sm: 6,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        flexDirection: "row",
        gap: 1,
        sx: {
            placeItems: 'center',
            border: '1px solid #DEE4EB',
            borderRadius: "8px",
            padding: '10px',
            backgroundColor: '#F4F7FA'
        }
    }, /*#__PURE__*/ React.createElement(DateAndTimeCalendarIcon, null), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            color: '#C3CCD6'
        },
        id: getSlotDateTime()
    }, getSlotDateTime())))), /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: 'row',
        width: '100%',
        sx: {
            marginTop: '20px'
        }
    }, lgMode && /*#__PURE__*/ React.createElement(MuiIconButton, {
        style: {
            width: '40px',
            height: '40px',
            backgroundColor: '#F4F7FA',
            justifyContent: 'center',
            padding: '10px',
            borderRadius: '8px',
            alignSelf: 'center',
            marginLeft: '5px',
            marginRight: '5px'
        },
        onClick: function () {
            scrollLeft();
        }
    }, /*#__PURE__*/ React.createElement("img", {
        id: "moreMenuIcon-left",
        src: ChevronLeft,
        alt: "settingIcon",
        style: {
            height: '24px',
            width: '24px',
            alignSelf: 'center'
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            flexDirection: 'row',
            width: lgMode ? '85%' : '100%',
            height: maxSlotValue * BAR_HEIGHT_MULTIPLIER + 30
        }
    }, /*#__PURE__*/ React.createElement("div", {
        id: "calendar-slots-scrollable",
        ref: function (el) {
            scrollableRef.current = el;
        },
        style: {
            display: 'flex',
            flexDirection: 'row',
            padding: 0,
            position: 'relative',
            width: '100%',
            overflowX: 'auto',
            height: '170px'
        }
    }, getCurrentCalendarData === null || getCurrentCalendarData === void 0 ? void 0 : getCurrentCalendarData.map(function (item, index) {
        var _moment, _moment2;
        return /*#__PURE__*/ React.createElement(MuiStack, null, index === 0 || Number(moment(item.FullDate).format('DD')) === 1 ? /*#__PURE__*/ React.createElement(Divider, {
            style: {
                height: maxSlotValue * BAR_HEIGHT_MULTIPLIER + 32
            },
            orientation: "vertical"
        }) : null, /*#__PURE__*/ React.createElement(MuiStack, {
            id: "current-date-data ".concat(index),
            style: {
                width: 35,
                height: (item === null || item === void 0 ? void 0 : item.AvailableSlots) * BAR_HEIGHT_MULTIPLIER,
                borderTopLeftRadius: 4,
                borderTopRightRadius: 4,
                backgroundColor: (_moment = moment(fullDate)) !== null && _moment !== void 0 && _moment.isSame(moment(item.FullDate)) ? '#3697FF' : '#EEF6FF',
                marginLeft: index == 0 ? 35 : 10,
                position: 'absolute',
                bottom: '45px',
                justifyContent: 'center',
                cursor: 'pointer'
            },
            onClick: function () { return onClickOfSlotBar(item); }
        }, ((_moment2 = moment(fullDate)) === null || _moment2 === void 0 ? void 0 : _moment2.isSame(moment(item.FullDate))) && /*#__PURE__*/ React.createElement(MuiStack, {
            zIndex: 900,
            direction: 'column',
            style: {
                top: '-25px',
                position: 'absolute',
                alignSelf: 'center',
                justifyContent: 'center'
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            border: "8px solid #1B1D21",
            style: {
                minWidth: 120,
                backgroundColor: 'black',
                padding: 0,
                borderRadius: '8px',
                alignSelf: 'center',
                justifyContent: 'center'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontSize: 'sm',
            fontWeight: 'strong',
            color: '#FFFFFF',
            textAlign: "center",
            id: "available-slot"
        }, 'Avl Slot ' + (item === null || item === void 0 ? void 0 : item.AvailableSlots) + '/' + (item === null || item === void 0 ? void 0 : item.TotalSlots))), /*#__PURE__*/ React.createElement(MuiStack, {
            style: {
                width: '12px',
                height: '12px',
                marginTop: '-8px',
                transform: "rotate(45deg)",
                backgroundColor: '#1B1D21',
                alignSelf: 'center',
                justifyContent: 'center'
            }
        }))), /*#__PURE__*/ React.createElement(MuiStack, {
            id: "select-date ".concat(index),
            direction: 'column',
            style: {
                width: 35,
                marginLeft: index === 0 ? 35 : 10,
                paddingTop: 5,
                alignItems: 'center',
                marginTop: maxSlotValue * BAR_HEIGHT_MULTIPLIER + 33
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "current-date ".concat(index),
            fontSize: 'sm',
            fontWeight: 'strong',
            color: 'secondary.900'
        }, item.Date), /*#__PURE__*/ React.createElement(Typography, {
            id: "current-date-name ".concat(index),
            fontSize: 'sm',
            fontWeight: 'strong',
            color: 'secondary.500'
        }, item.WeekdayShort)));
    }))), lgMode && /*#__PURE__*/ React.createElement(MuiIconButton, {
        style: {
            width: '40px',
            height: '40px',
            backgroundColor: '#F4F7FA',
            justifyContent: 'center',
            padding: '10px',
            borderRadius: '8px',
            alignSelf: 'center',
            marginLeft: '5px',
            marginRight: '5px'
        },
        onClick: function () {
            scrollRight(70);
        }
    }, /*#__PURE__*/ React.createElement("img", {
        id: "moreMenuIcon-right",
        src: ChevronRight,
        alt: "settingIcon",
        style: {
            height: '24px',
            width: '24px',
            alignSelf: 'center'
        }
    }))), /*#__PURE__*/ React.createElement(Divider, {
        style: {
            width: '100%',
            alignSelf: 'center',
            paddingTop: 1
        }
    })) : null;
}
export default CalendarComponent;
